module.exports = __webpack_public_path__ + "static/media/email.307b92fa.png";